import ComponentStore from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = <ComponentStore>{
  data: {
    'c__ARTICLE': {
      type: 'article',
      id: 'c__ARTICLE',
      childIds: []
    }
  },
  gerbera: {},
  isContentSaved: true,
  timeStampForSaveState: 0,
  history: {
    currentIndex: 0,
    patches: []
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
}
